<template>
  <div class="warp">
    <div class="loading" v-if="isLoading">
      <div class="loading-spinner"></div>
      <div class="loding-text">上传中...</div>
    </div>
    <div v-show="!isStartTakingPhotos">
      <input hidden type="file" multiple class="file-inp" accept="image/*" ref="picture" @change="selectFiles" />
      <div class="show-tag-grid">
        <div class="pictureitem" style="display: flex" v-for="(item, index) in showFiles" :key="index">
          <img style="width: 100%; height: 100%; border-radius: 12px" :src="item" alt="" />
          <img
            v-if="!item.startsWith('https://backend')"
            @click="delimg(index)"
            style="width: 20px; height: 20px; position: absolute; right: 0; top: 0"
            src="../assets/del.png"
            alt=""
          />
        </div>

        <div @click="clickupload" class="pictureitem" v-if="fileCount < maxCount">+</div>
      </div>
    </div>
    <div class="btn" v-show="!isStartTakingPhotos">
      <!-- <div class="upload" >本地图片</div> -->
      <div @click="selectAlbum" class="upload">相册</div>
      <div @click="clickupload" class="upload" v-if="fileCount === 0">拍照</div>
      <div class="upload" v-if="fileCount > 0" style="background: #00b26a" @click="submitupload">上传</div>
    </div>
    <CameraCapture v-if="isStartTakingPhotos" @process-pictures="processPictures" @to-preview="toPreview" />
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js';
  import Axios from 'axios';
  import Compressor from 'compressorjs';
  import CameraCapture from './camera.vue';

  export default {
    name: 'HelloWorld',
    props: {
      msg: String,
    },
    components: { CameraCapture },
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,
        maxCount: 25,
        showFiles: [],
        disabledbtn: true,
        uploadFiles: [],
        params: {
          tk: '',
          id: '',
          sd: '',
        },
        isStartTakingPhotos: false,
        isLoading: false,
      };
    },

    computed: {
      // 统一按 uploadFiles 计数：相册选图和拍照都会写这个数组。
      // 以前判断用的是 files.length，而相册选图根本不往 files 里写，
      // 所以只选相册不拍照时"上传"按钮永远不出现。
      fileCount() {
        return this.uploadFiles.length;
      },
    },

    methods: {
      resetParams() {
        this.params = {
          tk: '',
          id: '',
          sd: '',
        };
      },

      decryptData(encryptParams) {
        const bytes = CryptoJS.AES.decrypt(encryptParams, 'lioole-washkit');
        let result = bytes.toString(CryptoJS.enc.Utf8);
        return result;
      },

      async submitupload() {
        if (!this.disabledbtn) {
          window.alert('您已点击上传，请勿重复操作');
          return;
        }
        if (this.fileCount > this.maxCount) {
          alert('最多上传' + this.maxCount + '张图片');
          return;
        }
        let uploadList = [];
        this.uploadFiles.forEach(itt => {
          // console.log('dffffffffffffffff', itt);
          if (itt instanceof File) {
            uploadList.push(itt);
          }
        });

        if (uploadList.length == 0) {
          window.alert('请选择图片');
          return;
        }

        // 验证token
        if (!this.params.tk && !this.params.id && !this.params.sd) {
          window.alert('请通过二维码进入页面上传');
          this.exitToWeChat();
          return;
        }
        this.isLoading = true; // 开启loading
        // console.log(this.params, '11111111111111111111111111');
        let token = this.decryptData(this.params.tk);
        let itemId = this.params.id;
        let storeId = this.params.sd;

        // const formData = await this.convertFile()
        let formData = new FormData();
        // console.log(uploadList.length, token, 'dfdfdfdfdfdfdf');
        for (let i = 0; i < uploadList.length; i++) {
          formData.append('files', uploadList[i]);
        }
        this.disabledbtn = false;
        setTimeout(() => {
          // 使用axios或其他HTTP库发送POST请求
          // 这里只是示例，需要替换为实际的API地址和处理上传的逻辑
          let url =
            'https://backend.skzhixi.com:30443/admin/sys-file/batch/upload?storeId=' +
            storeId +
            '&type=1&itemId=' +
            itemId;
          // console.log('uuuuuuuuuuuuuuuuuuuuuuuuu', url, formData);
          Axios.post(url, formData, {
            headers: {
              authorization: token,
            },
          })
            .then(() => {
              this.isLoading = false; // 关闭loading
              window.alert('上传成功！');

              let relationUrl =
                'https://backend.skzhixi.com:30443/washkit/orders/relation/pic?storeId=' +
                storeId +
                '&itemId=' +
                itemId;

              Axios.get(relationUrl, {
                headers: {
                  authorization: token,
                },
              })
                .then(re => {
                  console.log('relation response:', re);
                })
                .catch(error => {
                  console.error('Error relation files:', error);
                });

              this.uploadFiles = [];
              this.showFiles = [];
              this.resetParams();
              // console.log('Files uploaded successfully:', response);
              this.disabledbtn = true;
              this.exitToWeChat();
            })
            .catch(() => {
              // console.error('Error uploading files:', error);
              window.alert('上传失败！');
              // 失败也要把 loading 关掉，否则页面会一直卡在"上传中"
              this.isLoading = false;
              this.disabledbtn = true;
            });
        }, 1000);

        // this.uploaddd(formData, token, itemId, storeId)
      },

      // 退出到微信的核心函数
      exitToWeChat() {
        if (typeof WeixinJSBridge !== 'undefined') {
          WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
          WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
        } else {
          document.addEventListener(
            'WeixinJSBridgeReady',
            () => {
              WeixinJSBridge.call('closeWindow'); // eslint-disable-line no-undef
            },
            false
          );
        }
        // 5秒后仍未关闭，提示用户手动操作
        setTimeout(() => {
          alert('请点击右上角"…"选择关闭返回微信');
        }, 5000);
      },

      async uploaddd(formData, token, itemId, storeId) {
        // 使用axios或其他HTTP库发送POST请求
        // 这里只是示例，需要替换为实际的API地址和处理上传的逻辑
        let url =
          'https://backend.skzhixi.com:30443/admin/sys-file/batch/upload?storeId=' +
          storeId +
          '&type=1&itemId=' +
          itemId;
        console.log('uuuuuuuuuuuuuuuuuuuuuuuuu', url);
        await Axios.post(url, formData, {
          headers: {
            authorization: token,
          },
        })
          .then(response => {
            // 反向关联
            window.alert('上传成功！');

            this.uploadFiles = [];
            this.showFiles = [];
            this.resetParams();
            console.log('Files uploaded successfully:', response);
          })
          .catch(error => {
            console.error('Error uploading files:', error);
            window.alert('上传失败！');
          });
      },

      async selectFiles(event) {
        const newFiles = Array.from(event.target.files);
        if (this.fileCount + newFiles.length > this.maxCount) {
          window.alert('图片数量不能大于' + this.maxCount + '张');
          event.target.value = '';
          return;
        }
        for (const file of newFiles) {
          await this.compressPhotos(file);
        }
        event.target.value = '';
      },

      selectAlbum() {
        this.$refs.picture.click();
      },

      compressPhotos(file) {
        return new Promise(resolve => {
          let fileSize = file.size / 1024;
          let quality = 0.9;
          if (fileSize < 1024) {
            quality = 1;
          }
          // else {
          //   quality = (1000 / fileSize).toFixed(2);
          // }

          let that = this;
          new Compressor(file, {
            quality: quality,
            maxWidth: 1024,
            maxHeight: 1024,
            success(result) {
              if (!result || !(result instanceof Blob)) {
                console.error('图片压缩失败：result 不是有效的 Blob 对象', result);
                alert('图片处理失败，请重试！');
                resolve(null);
                return;
              }
              let finalFile = new File([result], result.name || `photo_${Date.now()}.jpg`, {
                type: result.type || 'image/jpeg',
                lastModified: result.lastModified || Date.now(),
                lastModifiedDate: result.lastModifiedDate || new Date(),
                size: result.size,
              });
              let imageURL = URL.createObjectURL(finalFile);
              // 记下预览地址，删除时靠它和 showFiles 对应
              finalFile.previewUrl = imageURL;
              that.uploadFiles.push(finalFile);
              that.showFiles.push(imageURL);
              resolve(finalFile);
            },
            error(err) {
              console.error('图片压缩出错：', err);
              alert('图片处理失败，请重试');
              resolve(null);
            },
          });
        });
      },

      delimg(index) {
        const url = this.showFiles[index];
        if (!url) return;

        // showFiles 里还混着服务端返回的历史图片（没有对应的 File），
        // 索引和 uploadFiles 并不一一对应，按预览地址匹配才不会删错
        if (url.startsWith('blob:')) {
          const fileIndex = this.uploadFiles.findIndex(file => file && file.previewUrl === url);
          if (fileIndex > -1) this.uploadFiles.splice(fileIndex, 1);
          URL.revokeObjectURL(url);
        }
        this.showFiles.splice(index, 1);
      },

      clickupload() {
        // this.$refs.picture.click();
        this.isStartTakingPhotos = true;
      },
      // 处理拍的每张照片
      async processPictures(file) {
        console.log('processPictures 开始处理:', file.name || file);
        try {
          // compressPhotos 内部已经写入 uploadFiles / showFiles，这里不用再记一份
          await this.compressPhotos(file);
          console.log('compressPhotos 完成, 数量:', this.fileCount);
        } catch (err) {
          console.error('processPictures 错误:', err);
        }
      },
      // 不拍照了，预览
      toPreview() {
        this.isStartTakingPhotos = false;
      },
    },

    created() {},
    mounted() {
      let url = window.location.href;
      // 获取参数部分
      url = url.replaceAll('%20', '+');
      url = decodeURIComponent(url);
      let params = url.split('?')[1];

      // console.log('ddddddddddddddddddddd', params);
      // 将参数部分转换为对象
      if (params) {
        let paramsArr = params.split('&');
        for (let i = 0; i < paramsArr.length; i++) {
          let param = paramsArr[i].split('=');
          this.params[param[0]] = param[1];
        }
        let itemId = this.params.id;
        let tk = this.params.tk;
        let token = this.decryptData(tk);
        let relationUrl = 'https://backend.skzhixi.com:30443/washkit/orders/phone/photo?phoneUuid=' + itemId;
        Axios.get(relationUrl, {
          headers: {
            authorization: token,
          },
        })
          .then(re => {
            console.log('getImg response:', re);
            if (re.data.data && re.data.data.length) {
              re.data.data.forEach(itt => {
                let url = itt.host + itt.url;
                this.showFiles.push(url);
              });
            }
          })
          .catch(error => {
            console.error('Error relation files:', error);
          });

        // // 门店名称
        // localStorage.setItem('storeName', params.sn ? params.sn : '顺科智洗');

        // 获取拍照配置参数
        let url = 'https://backend.skzhixi.com:30443/washkit/setting/software/options';
        Axios.get(url, {
          headers: {
            authorization: token,
          },
        }).then(res => {
          if (res) {
            localStorage.setItem('cameraOptions', JSON.stringify(res));
          }
        });
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .warp {
    width: 100%;
    height: 100%;
  }

  .loading {
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.8);
  }

  .loading-spinner {
    border: 4px solid #f3f3f3; /* 浅色背景 */
    border-top: 4px solid #3498db; /* 蓝色高亮 */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .loding-text {
    margin-top: 10px;
    font-size: 18px;
    color: #fff;
  }

  .btn {
    position: absolute;
    bottom: 20px;
    width: 100%;
    height: 10%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .upload {
    width: 48%;
    height: 50px;
    line-height: 50px;
    background: #0ab95d;
    color: white;
    font-weight: 600;
    border-radius: 12px;
  }

  .pictureitem {
    width: 90%;
    position: relative;
    height: 140px;
    text-align: center;
    border: 1px solid rgba(57, 97, 205, 1);
    border-radius: 12px;
    /* margin-left: 5px; */
    line-height: 140px;
    font-size: 50px;
  }

  .show-tag-grid {
    width: 100%;
    height: 600px;
    display: grid;
    overflow-y: scroll;
    grid-gap: 40px 10px;
    grid-template-columns: repeat(2, minmax(40%, auto));
    grid-template-rows: repeat(5, minmax(auto, 50px));
  }
</style>
